import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { NimmstaCommonsModuleConfiguration } from '@nimmsta/ng-commons-lib/config';

export interface AppProfile {
  isWeclappProcessingActive: boolean;
}

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private http = inject(HttpClient);
  private configuration = inject(NimmstaCommonsModuleConfiguration);

  private profile?: AppProfile;

  public getProfile(): Observable<AppProfile> {
    if (this.profile) {
      return of(this.profile);
    }
    return this.http.get<AppProfile>(`${this.configuration.apiUrls.b2b}/api/profile`);
  }
}
